import state from './state'
import mutations from './mutations'
import actions from './actions'


const EmployeeModule = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
}

export default EmployeeModule